const ScreenshotContainer = (props) => {
  return <div className="card-img-top wordpress-preview">
      <img src={`https://image.thum.io/get/width/588/crop/500/maxAge/24/?url=${encodeURIComponent(props.url)}`} alt="Screenshot" />
    </div>
}

export {ScreenshotContainer}
